import React, { ComponentProps } from 'react'
import { Platform } from 'react-native'

import { styled } from 'nativewind'

import { Stack, XStack } from '../layout'
import { colors } from '../tailwind'
import { SH3 } from '../typography/Typography'

const StepperWrapper = styled(Stack, 'bg-neutral-white100 ', {
  variants: {
    stepperWidth: {
      small: 'w-28',
      medium: 'w-40',
      large: 'w-60',
      full: 'w-full',
    },
  },
  defaultProps: {
    stepperWidth: 'full',
  },
})
type StepperWrapperProps = ComponentProps<typeof StepperWrapper>

const StepperFrame = styled(Stack, 'flex-row bg-gray-100 ', {
  variants: {
    size: {
      small: 'rounded h-1',
      medium: 'rounded-md h-1.5',
      large: 'rounded-lg h-2',
      extraLarge: 'rounded-xl h-2.5',
    },
  },
  defaultProps: {
    size: 'small',
  },
})
type StepperFrameProps = ComponentProps<typeof StepperFrame>

const StepperProgress = styled(Stack, 'flex-row', {
  variants: {
    intent: {
      primary: 'bg-primary-100',
      error: `bg-error-100`,
      success: `bg-success-100`,
      warning: `bg-warning-100`,
    },
    size: {
      small: Platform.OS === 'web' ? 'rounded h-1' : 'rounded',
      medium: 'rounded-md',
      large: 'rounded-lg',
      extraLarge: 'rounded-xl',
    },
  },
  defaultProps: {
    intent: 'primary',
    size: 'small',
  },
})

type StepperProgressProps = ComponentProps<typeof StepperProgress>
type StepperProps = StepperFrameProps &
  StepperWrapperProps &
  StepperProgressProps & {
    minCount: number
    maxCount: number
    progressColor?: string
  }
export function Stepper({
  maxCount,
  minCount,
  intent,
  size,
  stepperWidth,
  progressColor = colors.primary[100],
  ...props
}: StepperProps) {
  const widthPercentage = (minCount / maxCount) * 100

  return (
    <StepperWrapper stepperWidth={stepperWidth} {...props}>
      <SH3>
        Step {minCount}
        {maxCount ? `/${maxCount}` : ''}
      </SH3>
      <XStack className="h-1" />
      <StepperFrame size={size}>
        <StepperProgress
          style={{
            width: `${widthPercentage}%`,
          }}
          size={size}
          intent={minCount == maxCount ? 'success' : intent}
        />
      </StepperFrame>
    </StepperWrapper>
  )
}
